// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  manualEntryPaymentFormSchema,
  ManualEntryPaymentValuesType,
  manualEntryPaymentInitialValues,
} from "./_formTypes";
import {
  GetListUnMatchTransactionRequest,
  useGetListUnMatchTransaction,
  PagingResponse,
  useAuthorization,
  useGetMerchantsWithParentMerchant,
  useAddUnMatchTransaction,
} from "../../../hooks";
import { RequestFilterValueTypeEnums, RequestFilterOperationTypeEnum, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';
import { createBooleanOperator } from '../../atoms/grid-filter-operations';
import {
  GridColDef,
  GridActionsCellItem,
  GridPaginationModel,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { default as dayjs } from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
  FormControl,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Button, Loading } from "../../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import { Table, DatePickerControl } from "../../molecules";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import { useLocation } from "react-router-dom";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";

export const WorkplaceEntitlementManualEntryComponent = () => {
  const theme = useTheme();
  const user = useLocation().state as unknown as IUser | undefined;
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const { control, handleSubmit, setValue, getValues } =
    useForm<ManualEntryPaymentValuesType>({
      resolver: zodResolver(manualEntryPaymentFormSchema),
      defaultValues: manualEntryPaymentInitialValues,
    });
  const [selectedRows, setSelectedRows] = useState([]);
  const [showTable, setShowTable] = useState(false)
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: -1,
  });
  const [tableselectedRow, setTableSelectedRow] = useState({} as any);
  const [prevQueryOptions, setPrevQueryOptions] = useState({});
  const {
    mutate: GetListUnMatchTransaction,
    isLoading: isGetListUnMatchTransactionLoading,
  } = useGetListUnMatchTransaction();
  const {
    mutate: AddUnMatchTransaction,
    isLoading: isAddUnMatchTransacitonLoading,
  } = useAddUnMatchTransaction();
  const setSnackbar = useSetSnackBar();
  // const { data: rawMerchantList } = useGetAllMerchantList("ACTIVE");
  const { data: rawMerchantList, isLoading: isMerchantListLoading } =
    useGetMerchantsWithParentMerchant("ACTIVE");

  const [userInfo] = useUserInfo();
  useEffect(() => {
    const currentDate = dayjs();
    setValue("startDate", currentDate);
    setValue("endDate", currentDate);
  }, [setValue]);
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const [selectedMerchant, setSelectedMerchant] = useState(
    user
      ? Number(userInfo.merchantId) !== 0
        ? { label: userInfo.merchantName, value: Number(userInfo.merchantId) }
        : null
      : null
  );

  const merchantList = useMemo(() => {
    return rawMerchantList?.data?.map(
      (rawPosType: { merchantName: string; merchantId: number }) => {
        return {
          label: rawPosType.merchantName,
          value: rawPosType.merchantId,
        };
      }
    );
  }, [rawMerchantList?.data]);

  const [formValues, setFormValues] =
    useState<ManualEntryPaymentValuesType | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [dynamicFilters, setDynamicFilter] = useState<any>([]);

  useEffect(() => {
    if (!isSubmitted || !formValues) {
      return;
    }

    const requestPayload = {
      ...formValues,
      filters: dynamicFilters,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    GetListUnMatchTransaction(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
        } else {
          setTableData(data.data);
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  }, [dynamicFilters, queryOptions]);

  const convertTableFiltersToRequestFilter = (tableFilters: any) => {
    let convertedFilters: any = [];

    tableFilters.items.map((item: any) => {
      var findColumn = columns.find(x => x.field == item.field);

      convertedFilters.push({
        field: item.field,
        values: [item.value.toString()],
        valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
        operationType: mapReactMUIToFilterOperationTypes(item.operator)
      });
    });

    return convertedFilters;
  }

  const onSubmit = (data: ManualEntryPaymentValuesType) => {
    setFilterAccordionExpand(false);
    setTableData(undefined);
    setShowTable(true)
    const req: GetListUnMatchTransactionRequest = {
      page: paginationModel.page,
      size: paginationModel.pageSize,
      orderByDesc: true,
      orderBy: "CreateDate",
      status: "ACTIVE",
      startDate: data?.startDate
        ? dayjs(data.startDate).format("YYYY-MM-DD")
        : "",
      endDate: data?.endDate ? dayjs(data.endDate).format("YYYY-MM-DD") : "",
      filters: dynamicFilters,
    };
    setFormValues(req);
    setIsSubmitted(true);
    GetListUnMatchTransaction(req, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);

          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setTableData(data.data);
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };
  // useEffect(() => {
  //   if (!isSubmitted || !formValues) {
  //     return;
  //   }
  //   setPrevQueryOptions(queryOptions);
  //   const requestPayload = {
  //     ...formValues,
  //     ...getQueryParams(queryOptions),
  //   };

  //   if (queryOptions?.field && queryOptions?.value !== undefined) {
  //     requestPayload[queryOptions.field] = queryOptions.value;
  //   }

  //   GetListUnMatchTransaction(requestPayload, {
  //     onSuccess: (data) => {
  //       if (data.isSuccess) {
  //         setTableData(data.data);
  //         setSnackbar({
  //           severity: "success",
  //           isOpen: true,
  //           description: data.message,
  //         });
  //       } else {
  //         setQueryOptions(prevQueryOptions);
  //         setTableData(data.data);
  //         setSnackbar({
  //           severity: "error",
  //           description: data.message,
  //           isOpen: true,
  //         });
  //       }
  //     },
  //     onError: () => {
  //       setSnackbar({
  //         severity: "error",
  //         description: "İşlem sırasında bir hata oluştu",
  //         isOpen: true,
  //       });
  //       setQueryOptions(prevQueryOptions);
  //     },
  //   });
  // }, [formValues, isSubmitted, queryOptions, shouldRefresh]);

  const ManualEntry = ({ AddUnMatchTransaction, id }) => {
    const handleManualEntryAdd = () => {
      AddUnMatchTransaction(
        { id: id },
        {
          onSuccess: (data) => {
            if (data.isSuccess) {
              setSnackbar({
                severity: "success",
                description: data.message || "İşlem başarılı.",
                isOpen: true,
              });
              const requestPayload = {
                page: paginationModel.page,
                size: paginationModel.pageSize,
                orderByDesc: true,
                orderBy: "CreateDate",
                status: "ACTIVE",
                startDate: getValues("startDate")
                  ? dayjs(getValues("startDate")).format("YYYY-MM-DD")
                  : "",
                endDate: getValues("endDate")
                  ? dayjs(getValues("endDate")).format("YYYY-MM-DD")
                  : "",
                filters: dynamicFilters,
                ...getQueryParams(queryOptions),
              };

              GetListUnMatchTransaction(requestPayload, {
                onSuccess: (refreshData) => {
                  setTableData(refreshData.data);
                  if (!refreshData.isSuccess) {
                    setSnackbar({
                      severity: "error",
                      description: refreshData.message,
                      isOpen: true,
                    });
                  } else if (!refreshData.data?.result || refreshData.data.result.length === 0) {
                    setSnackbar({
                      severity: "info",
                      description: refreshData.message || "Kayıt bulunamadı",
                      isOpen: true,
                    });
                  }
                },
                onError: () => {
                  setSnackbar({
                    severity: "error",
                    description: "Tablo yenilenirken bir hata oluştu.",
                    isOpen: true,
                  });
                },
              });
            } else {
              setSnackbar({
                severity: "error",
                description: data.message,
                isOpen: true,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              description: "İşlem sırasında bir hata oluştu.",
              isOpen: true,
            });
          },
        }
      );
    };

    return (
      <Button
        text="Manuel Ekle"
        variant="contained"
        color="primary"
        textTransform="capitalize"
        sx={{ flex: 1, height: 20, py: 5 }}
        onClick={handleManualEntryAdd}
      ></Button>
    );
  };

  const deleteRow = React.useCallback(
    (transaction: any) => () => {
      setTableSelectedRow(transaction);
    },
    []
  );

  const booleanOptions = [
    { label: "Evet", value: true },
    { label: "Hayır", value: "false" },
  ];
  const currencyDescOption = [
    { label: "TRY", value: "TRY" },
    { label: "USD", value: "USD" },
    { label: "EUR", value: "EUR" }
  ];

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "manualEntry",
        headerName: "Manuel Ekle",
        width: 150,
        filterable: false,
        renderCell: (params) => {
          return (
            <ManualEntry
              id={params.row.id}
              AddUnMatchTransaction={AddUnMatchTransaction}
            />
          );
        },
      },
      { 
        field: "uyeRefNo", 
        headerName: "Sipariş Numarası", 
        width: 330,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      { 
        field: "onayKodu", 
        headerName: "Otorizasyon Kodu", 
        width: 150,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "brutTutar",
        headerName: "Toplam Tutar",
        width: 150,
        type: "decimal",
        columnType: RequestFilterValueTypeEnums.NUMBER,
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          params.value ? `${params.value} TL` : '',
      },
      {
        field: "netTutar",
        headerName: "Tutar",
        width: 120,
        type: "decimal",
        columnType: RequestFilterValueTypeEnums.NUMBER,
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          params.value ? `${params.value} TL` : '',
      },
      {
        field: "komisyon",
        headerName: "Komisyon",
        width: 150,
        type: "decimal",
        columnType: RequestFilterValueTypeEnums.NUMBER,
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          params.value ? `${params.value} TL` : '',
      },
      {
        field: "komisyonOrani",
        headerName: "Komisyon Oranı",
        width: 150,
        type: "decimalPercentage",
        columnType: RequestFilterValueTypeEnums.NUMBER,
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          params.value ? `${params.value} %` : '',
      },
      { 
        field: "bankCode", 
        headerName: "Banka Kodu", 
        width: 120,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      { 
        field: "posNo", 
        headerName: "Terminal", 
        width: 150,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      { 
        field: "kartNo", 
        headerName: "Kart Numarası", 
        width: 180,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      { 
        field: "taksitSayisi", 
        headerName: "Taksit Sayısı", 
        width: 150,
        type: "number",
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      { 
        field: "islemTarihi", 
        headerName: "İşlem Tarihi", 
        width: 150,
        columnType: RequestFilterValueTypeEnums.DATE
      },

    ];
  }, [deleteRow, showDelete]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);

    const requestPayload = {
      startDate: getValues("startDate")
        ? dayjs(getValues("startDate")).format("YYYY-MM-DD")
        : "",
      endDate: getValues("endDate")
        ? dayjs(getValues("endDate")).format("YYYY-MM-DD")
        : "",
      status: "ACTIVE",
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      filters: dynamicFilters,
    };

    GetListUnMatchTransaction(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const onSave = () => {
    const requestPayload = {
      page: 0,
      size: -1,
      orderBy: "CreateDate",
      status: "ACTIVE",
      merchantId: getValues("merchantId"),
      orderByDesc: true,
      startDate: dayjs(getValues("startDate")).format("YYYY-MM-DD"),
      endDate: dayjs(getValues("endDate")).format("YYYY-MM-DD"),
      filters: dynamicFilters,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    GetListUnMatchTransaction(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          function fieldValue(data) {
            return data.map((item) => {
              return {
                "Sipariş Numarası": item?.uyeRefNo,
                "Otorizasyon Kodu": item?.onayKodu || " ",
                "Toplam Tutar": item?.brutTutar,
                "Tutar": item?.netTutar,
                "Komisyon": item?.komisyon,
                "Komisyon Oranı": item?.komisyonOrani,
                "Banka Kodu": item?.bankCode || " ",
                "Terminal": item?.posNo,
                "Kart Numarası": item?.kartNo || " ",
                "Taksit Sayısı": item?.taksitSayisi || " ",
                "İşlem Tarihi": item?.islemTarihi,


              };
            });
          }
          const refactoredData = fieldValue(data?.data?.result);
          downloadExcel(refactoredData || [], "İşyeri Hak Ediş Manuel Ekleme");
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      let value = filters[key];
      // Eğer gelen değer string "false" ise onu boolean false'a çevir
      if (value === "false") {
        queryParams[key] = false;
      } else {
        if (value !== null && value !== undefined && value.toString().length > 0) {
          queryParams[key] = value;
        }
      }
    }
    return queryParams;
  };


  const handleFilterChange = debounce((filters, tableFilters) => {
    if (filters.clearFilter) {
      setDynamicFilter([]);
      return setQueryOptions({});
    }


    const queryParams = getQueryParams(filters);

    const isValueValid = (key, value) => {
      if (key === 'taksitSayisi' || key === 'cardType') { // Özel alan kontrolü
        return value?.toString().length >= 1;
      } else {
        return value?.toString().length >= 3;
      }
    }


    const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if (allValuesValid || (previousKeysLength > currentKeysLength)) {
      setQueryOptions(queryParams);
      setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
    }


    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});
  const hasLoading =
    isGetListUnMatchTransactionLoading ||
    isAddUnMatchTransacitonLoading ||
    isMerchantListLoading;

  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);

  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>
          <BaseFilterTableWithAccordion summary="Eşleşmeyen İşlemler" isExpanded={isFilterAccordionExpanded} setExpanded={setFilterAccordionExpand} setTableVisibility={setShowTable}
            child={<Stack spacing={4}>
              <Stack
                spacing={5}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? 800 : "auto"}
              >
                <FormControl sx={{ flex: 1 }}>
                  <DatePickerControl
                    sx={{ flex: 1 }}
                    id="startDate"
                    label="Gün Sonu Başlangıç Tarihi"
                    defaultValue={dayjs().subtract(1, "day")}
                    control={control}
                  />
                </FormControl>

                <FormControl sx={{ flex: 1 }}>
                  <DatePickerControl
                    sx={{ flex: 1 }}
                    id="endDate"
                    control={control}
                    label="Gün Sonu Bitiş Tarihi"
                    defaultValue={dayjs()}
                  />
                </FormControl>

              </Stack>

              <Stack
                direction="row"
                justifyContent="flex-end"
                width={isDesktop ? 800 : "auto"}
              >
                <Button
                  onClick={handleSubmit(onSubmit)}
                  variant="contained"
                  text={"ARA"}
                />
              </Stack>
            </Stack>} />

          <Stack flex={1} mt={2}>
            {showTable && (
              <>
                <Table
                  filterKey="ManualEntryFilterKey"
                  columnVisibilityConfigKey="ManualEntryColumnVisibilityKey"
                  className="myTable"
                  hasActiveFilters={hasActiveFilters}
                  handleFilterChange={handleFilterChange}
                  paginationModel={paginationModel}
                  onPaginationModelChange={handleChangePagination}
                  paginationMode="server"
                  rowCount={tableData?.totalItems || 0}
                  disableRowSelectionOnClick
                  sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
                  // isRowSelectable={() => false}
                  rows={tableData?.result || []}
                  autoHeight={!isDesktop}
                  customLabelDisplayedRows={true}
                  columns={columns}
                  exportFileName="İşyeri Hak Ediş Manuel Ekleme"
                  onSave={() => onSave()}
                />
              </>
            )}
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
